import React, { useState, useEffect } from 'react';
import {
  Button, Container, FormControl, InputLabel, Box, Modal, Tooltip, MenuItem, Select,
  Paper, TextField, Typography, InputAdornment, IconButton
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import { decimalOnly, digitsOnly } from '../../../utils/numericInput';

const AddEnquiryQuotation = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [searchEnquiry, setSearchEnquiry] = useState('');
  const [quotationDate, setQuotationDate] = useState('');
  const [candidateName, setCandidateName] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [email, setEmail] = useState('');
  const [countryId, setCountryId] = useState('');
  const [stateId, setStateId] = useState('');
  const [cityId, setCityId] = useState('');
  const [noOfPerson, setNoOfPerson] = useState('');
  const [noOfSession, setNoOfSession] = useState('');
  const [totalFee, setTotalFee] = useState('');
  const [course, setCourse] = useState('');

  const navigate = useNavigate();

  // Static data for countries, states, and cities
  const staticCountryData = [
    { countryId: 1, countryName: 'India' },
  ];

  const staticStateData = [
    { stateId: 1, stateName: 'Bihar' },
    { stateId: 2, stateName: 'Jharkhand' },
  ];

  const staticCityData = [
    { cityId: 1, cityName: 'Patna' },
    { cityId: 2, cityName: 'Ranchi' },
  ];

  useEffect(() => {
    // Set today's date when the component mounts
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    setQuotationDate(formattedDate);
  }, []);

  const handleSave = (e) => {
    e.preventDefault();
    if (candidateName && mobileNo && email && countryId && stateId && cityId && noOfPerson && noOfSession && totalFee && course) {
      setShowSuccessModal(true);
    } else {
      alert('Please fill all fields');
    }
  };

  const handleCancel = () => {
    setSearchEnquiry('');
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    setQuotationDate(formattedDate);
    setCandidateName('');
    setMobileNo('');
    setEmail('');
    setCountryId('');
    setStateId('');
    setCityId('');
    setNoOfPerson('');
    setNoOfSession('');
    setTotalFee('');
    setCourse('');
  };

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '0 auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Add Enquiry Quotation
        </Typography>
      </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <form onSubmit={handleSave}>
          <TextField
            label="Search Enquiry"
            variant="outlined"
            fullWidth
            value={searchEnquiry}
            onChange={(e) => setSearchEnquiry(e.target.value)}
            sx={{ mb: 3 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Quotation Date"
            type="date"
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            value={quotationDate}
            onChange={(e) => setQuotationDate(e.target.value)}
            sx={{ mb: 3 }}
          />
          <TextField
            label="Candidate Name"
            variant="outlined"
            fullWidth
            value={candidateName}
            onChange={(e) => setCandidateName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <TextField
            label="Mobile No."
            variant="outlined"
            fullWidth
            value={mobileNo}
            onChange={(e) => setMobileNo(e.target.value)}
            sx={{ mb: 3 }}
          />
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mb: 3 }}
          />
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel id="country-label">Country</InputLabel>
            <Select
              labelId="country-label"
              id="country"
              value={countryId}
              label="Country"
              onChange={(e) => setCountryId(e.target.value)}
            >
              {staticCountryData.map((countryItem) => (
                <MenuItem key={countryItem.countryId} value={countryItem.countryId}>
                  {countryItem.countryName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel id="state-label">State</InputLabel>
            <Select
              labelId="state-label"
              id="state"
              value={stateId}
              label="State"
              onChange={(e) => setStateId(e.target.value)}
            >
              {staticStateData.map((stateItem) => (
                <MenuItem key={stateItem.stateId} value={stateItem.stateId}>
                  {stateItem.stateName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel id="city-label">City</InputLabel>
            <Select
              labelId="city-label"
              id="city"
              value={cityId}
              label="City"
              onChange={(e) => setCityId(e.target.value)}
            >
              {staticCityData.map((cityItem) => (
                <MenuItem key={cityItem.cityId} value={cityItem.cityId}>
                  {cityItem.cityName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="No. of Person"
            variant="outlined"
            fullWidth
            value={noOfPerson}
            onChange={(e) => setNoOfPerson(digitsOnly(e.target.value))}
            inputProps={{ inputMode: 'numeric' }}
            sx={{ mb: 3 }}
          />
          <TextField
            label="No. of Session"
            variant="outlined"
            fullWidth
            value={noOfSession}
            onChange={(e) => setNoOfSession(digitsOnly(e.target.value))}
            inputProps={{ inputMode: 'numeric' }}
            sx={{ mb: 3 }}
          />
          <TextField
            label="Total Fee"
            variant="outlined"
            fullWidth
            value={totalFee}
            onChange={(e) => setTotalFee(decimalOnly(e.target.value))}
            inputProps={{ inputMode: 'decimal' }}
            sx={{ mb: 3 }}
          />
          <TextField
            label="Course"
            variant="outlined"
            fullWidth
            value={course}
            onChange={(e) => setCourse(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={
            !candidateName ? "Enter Candidate Name" :
            !mobileNo ? "Enter Mobile No." :
            !email ? "Enter Email" :
            !countryId ? "Select Country" :
            !stateId ? "Select State" :
            !cityId ? "Select City" :
            !noOfPerson ? "Enter No. of Person" :
            !noOfSession ? "Enter No. of Session" :
            !totalFee ? "Enter Total Fee" : "Enter Course"
          } arrow>
            <span>
              <Button
                variant="contained"
                type="submit"
                sx={{
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
                disabled={!candidateName || !mobileNo || !email || !countryId || !stateId || !cityId || !noOfPerson || !noOfSession || !totalFee || !course}
              >
                SAVE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            RESET
          </Button>
        </form>
      </Paper>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Enquiry Quotation Added ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Enquiry Quotation Added Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default AddEnquiryQuotation;
